import { render, staticRenderFns } from "./NomalList.vue?vue&type=template&id=e82e07ee&scoped=true"
import script from "./NomalList.vue?vue&type=script&lang=js"
export * from "./NomalList.vue?vue&type=script&lang=js"
import style0 from "./NomalList.vue?vue&type=style&index=0&id=e82e07ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82e07ee",
  null
  
)

export default component.exports